module.exports = __webpack_public_path__ + "img/dgitem8.2377677d.png";